import { FC } from "react";
import { Card, makeStyles, Typography, useMediaQuery } from "@material-ui/core";
import { Add as AddIcon } from "@material-ui/icons";
import { Link } from "react-router-dom";

import * as routes from "routes";
import theme, { Theme } from "theme";

const useStyles = makeStyles<Theme, { isSmDown: boolean }>(() => ({
  card: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(3),
    width: "100%",
    minHeight: props => (props.isSmDown ? "unset" : "245px"),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    "&:hover": {
      backgroundColor: theme.custom.palette.purple.lightest,
      color: theme.custom.palette.purple.main,
    },
  },
  icon: {
    fontSize: "4rem",
    marginTop: theme.spacing(1),
  },
}));

const AddNewAccountCardCard: FC = ({}) => {
  const isSmDown = useMediaQuery(theme.breakpoints.down("sm"));
  const classes = useStyles({ isSmDown });

  return (
    <Link to={routes.sellerAddRoyaltyAccount()}>
      <Card elevation={3} className={classes.card}>
        <Typography variant="h5">Add New Royalty Account</Typography>
        <AddIcon className={classes.icon} />
      </Card>
    </Link>
  );
};

export default AddNewAccountCardCard;
